import React, { useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Button } from "src/@/components/ui/button";
import useAuth from 'src/hooks/useAuth';

const GoogleLogin = ({ clientId, onLoginSuccess }) => {
    const { cliente } = useAuth();
    const [user, setUser] = useState(null);

    const handleLogin = () => {
        // Redireciona para o endpoint do backend que inicia o fluxo OAuth
        const urlAuth = `http://localhost:3005/api/google/auth/${cliente._id}/redirect-url?email=jaoteixeira12@gmail.com`;
        window.location.href = urlAuth;
    };

    // Detecta o callback com os dados do usuário
    const handleCallback = () => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const loged = params.get('loged') === 'true';

        if (loged && email) {
            setUser({ email });
            if (onLoginSuccess) {
                onLoginSuccess({ email });
            }
        }
    };

    React.useEffect(() => {
        // Verifica se o callback foi chamado
        handleCallback();
    }, []);

    const handleLogout = () => {
        setUser(null);
        alert('Você saiu da conta!');
    };

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <div className="flex flex-col mt-4">
                {!user ? (
                    <div className="flex flex-col gap-2">
                        <p className="text-xs">Entre com sua conta Google para vincular o calendário</p>
                        <Button onClick={handleLogin} className="bg-blue-300 hover:bg-blue-600 text-white w-[150px] h-8">
                            Vincular conta
                        </Button>
                    </div>
                ) : (
                    <div className="flex flex-col rounded p-4 border bg-slate-50">
                        <p className="text-xs">Conta Google configurada:</p>
                        <span className="font-bold">{user.email}</span>
                        <Button
                            onClick={handleLogout}
                            className="bg-red-300 hover:bg-red-600 text-white w-[150px] h-8 mt-4"
                        >
                            Desvincular conta
                        </Button>
                    </div>
                )}
            </div>
        </GoogleOAuthProvider>
    );
};

export default GoogleLogin;
